// https://talkytimes.com/platform/icebreakers/limits

import { requestPDServer } from '@/utils/fetchResponse';
import request from '@/api/request';
const myBaseUrl = process.env.VUE_APP_BASE_API;
import Cookies from 'js-cookie';
// const userInfo = store.getters['socket/getUserInfo'](platformUserId);

// /platform/news-feed/post/list
export const getNewsFeedList = (data) => {
  return requestPDServer('/platform/news-feed/post/list', data);
};
// 创建帖子
// https://talkytimes.com/platform/news-feed/post/create
// content：{
//   "text": "string",
//   "images": [49342137,49342138]
// },
// type:'post'
export const createNewsFeedPost = (data) => {
  return requestPDServer('/platform/news-feed/post/create', data);
};

// 发送帖子
// https://talkytimes.com/platform/news-feed/post/send
// id: 帖子id
export const sendNewsFeedPost = (data) => {
  return requestPDServer('/platform/news-feed/post/send', data);
};

// 删除帖子
// https://talkytimes.com/platform/news-feed/post/delete
// id: 帖子id
// status: 帖子状态 on_moderation,approved,declined,sent
export const deleteNewsFeedPost = (data) => {
  return requestPDServer('/platform/news-feed/post/delete', data);
};
// 重新发送帖子
// https://talkytimes.com/platform/news-feed/post/resend
// id: 帖子id
export const resendNewsFeedPost = (data) => {
  return requestPDServer('/platform/news-feed/post/resend', data);
};
// 已发送帖子列表
// /platform/news-feed/candidate/list
// {"limit":4,"idLast":0}
// limit: 每页条数
// idLast: 上一次请求的最后一条id
// 返回数据：
// [
//   {
//       "id": 9444136,
//       "idUser": 120207443,
//       "idPost": 12519993,
//       "type": "post",
//       "date_created": "2025-08-25T01:26:03+00:00",
//       "content": {
//           "text": "May your eyes shine brightly and you strive to live the life you want.",
//           "images": [
//               {
//                   "id": 48913286,
//                   "urlPreview": "https://i.gstatvb.com/shpzkl15423f3qjpo.r100x100.e53665d8.jpg",
//                   "urlStandart": "https://i.gstatvb.com/shpzkl15423f3qjpo.r800x800.f.ca8a2fb9.jpg"
//               }
//           ]
//       }
//   }
// ]
export const getNewsFeedCandidateList = (data) => {
  return requestPDServer('/platform/news-feed/candidate/list', data);
};

// 获取所有用户的最新帖子时间
export const getUserLastPostTimes = () => {
  // 模拟接口响应，实际项目中应该调用真实的AP
  return request({
    url: '/newsfeed/getPdNewsfeedCountdownList',
    method: 'post',
    headers: {
      isEncrypt: false,
    },
  });
};

const setCookie = () => {
  const activeUser = localStorage.getItem('activeUser');
  if (activeUser) {
    const user = JSON.parse(activeUser);
    Cookies.set('tld-token', user.pdToken);
  }
};
